module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "400px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Map the Influencer on behalf\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [(_vm.postData.length) ? _c('p', [_vm._v("\n        Mapping influencer for "), _c('strong', [_vm._v(_vm._s(_vm.postData.length))]), _vm._v(" selected posts.\n      ")]) : _vm._e(), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Instagram",
      "value": "instagram"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "TikTok",
      "value": "tiktok"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Youtube",
      "value": "youtube"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "LinkedIn",
      "value": "linkedin"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prefix": "@",
      "label": "Handle",
      "block": "",
      "disabled": _vm.isValidating,
      "outlined": ""
    },
    model: {
      value: (_vm.handle),
      callback: function($$v) {
        _vm.handle = $$v
      },
      expression: "handle"
    }
  }), _vm._v(" "), (_vm.postData.length) ? _c('table', {
    staticClass: "post-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Influencer")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Campaign")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.postData), function(item, index) {
    return _c('tr', {
      key: item._id || index
    }, [_c('td', {
      staticClass: "text-xs-justify pa-1"
    }, [(item.author && item.author.tiktokHandle) ? _c('a', {
      attrs: {
        "href": 'https://www.tiktok.com/@' + item.author.tiktokHandle,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(item.author.tiktokHandle))]) : (item.author && item.author.youtubeHandle) ? _c('a', {
      attrs: {
        "href": 'https://youtube.com/' + item.author.youtubeHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(item.author.youtubeHandle))], 1) : (item.author && item.author.linkedinHandle) ? _c('a', {
      attrs: {
        "href": 'https://www.linkedin.com/in/' + item.author.linkedinHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(item.author.linkedinHandle))], 1) : (item.author && item.author.instagramHandle) ? _c('a', {
      attrs: {
        "href": 'https://instagram.com/' + item.author.instagramHandle,
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.author.instagramHandle))], 1) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left"
    }, [_vm._v(_vm._s(item.campaignName || '-'))])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveMappedInfluencer()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c19040"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/MapInfluencerMultipleModal.vue
// module id = 2035
// module chunks = 0